import assetMetadata from "@wielink-application/asset/js/mixins/assetMetadata";

// Bouwt op assetMetadata: bepaalt per bestand in modelValue of er verplichte metadata
// ontbreekt en meldt het totaal via setAssetFieldValidity (zie assetFields mixin),
// zodat het globale formulier niet opgeslagen kan worden zolang er velden ontbreken.
// Vereist een component met formInput (modelValue, name) en een assetableGroup prop.
export default {
	mixins: [assetMetadata],
	inject: {
		setAssetFieldValidity: {default: null},
	},
	computed: {
		requiredMetadataFields() {
			return this.metadataFields.filter((field) => field.required);
		},
		missingMetadataCount() {
			let assets = Array.isArray(this.modelValue) ? this.modelValue : [];
			return assets.filter((asset) => !asset.deleted && this.missesRequiredMetadata(asset)).length;
		},
		metadataWarningHint() {
			return 'Er zijn verplichte velden die nog ingevuld moeten worden.';
		}
	},
	watch: {
		missingMetadataCount: {
			immediate: true,
			handler(count) {
				this.setAssetFieldValidity?.(this.name, count);
			}
		}
	},
	mounted() {
		if (this.assetableGroup) {
			this.fetchMetadataFields(this.assetableGroup);
		}
	},
	beforeUnmount() {
		this.setAssetFieldValidity?.(this.name, 0);
	},
	methods: {
		// clearMetadata van de assetMetadata mixin reset ook form.metadata, maar in deze
		// componenten is this.form het globale formulier; alleen de eigen definities leegmaken.
		clearMetadata() {
			this.metadataFields = [];
			this.currentGroup = null;
		},
		missesRequiredMetadata(asset) {
			return this.requiredMetadataFields.some((field) => this.isEmptyMetadataValue(asset.metadata?.[field.name]));
		},
		isEmptyMetadataValue(value) {
			return value === null || value === undefined || String(value).trim() === '';
		}
	}
}
